<template>
    <span>Trwa wylogowywanie</span>
</template>

<script>
export default {
    name: "route-logout",
    route: {
        path: '/logout',
        before() {

            this.$auth.logout().finally(() => {
                this.$router.push({ name: "login" }).catch(e => {
                    console.warn(e);
                })
            });
        }
    }
}
</script>
